import { ActionType } from "./actions";
import { IMediaGalleryItem, IMediaGalleryFilterResponse } from "../../../classes/media-gallery";
import axios, { AxiosResponse } from "axios";
import { MediaGalleryAppState } from "../../../classes/index";
import { Dispatch } from "react-redux";

declare const pageId: number;

/**
 * The number of medias to pull for every API call.
 */
const pageSize = 9;

export function storeFilteredMedia(medias: IMediaGalleryItem[]) {
    return {
        type: ActionType.STORE_FILTERED_MEDIA,
        value: medias
    }
}

function requestFilters() {
    return {
        type: ActionType.REQUEST_FILTERS
    }
}

function filtersResponse(response: AxiosResponse<IMediaGalleryFilterResponse>) {
    const items = response.data;

    return {
        type: ActionType.RECEIVE_FILTERS,
        value: items
    }
}

export function getFilters() {
    return (dispatch: Dispatch<MediaGalleryAppState>, getState: () => MediaGalleryAppState) => {
        dispatch(requestFilters());

        axios.get<IMediaGalleryFilterResponse>(`/api/MediaGallery/GetFilterOptions?epiPageID=${pageId}`).then(response => {
            dispatch(filtersResponse(response));
        });
    }
}


function requestMedia() {
    return {
        type: ActionType.REQUEST_NEXT_BATCH
    }
}

function mediaResponse(response: AxiosResponse<IMediaGalleryItem[]>, ) {
    const items = response.data;
    const noMoreMedia = items.length < pageSize;

    return {
        type: ActionType.RECEIVE_NEXT_BATCH,
        value: {
            medias: items, noMoreMedia: noMoreMedia
        }
    }
}


export function getMedia() {
    return (dispatch: Dispatch<MediaGalleryAppState>, getState: () => MediaGalleryAppState) => {
        // Get the state before the batch number is incremented.
        let state = getState();
        dispatch(requestMedia());
        axios.get<IMediaGalleryItem[]>(`/api/MediaGallery/GetMedia?epiPageID=${pageId}&startAtIndex=${state.mediaApiModel.currentBatch * pageSize}&pageSize=${pageSize}`).then(response => {
            dispatch(mediaResponse(response));

            state = getState();

            const filteredMedia = state.mediaApiModel.mediaList.filter(state.filterModel.combinedFilter);
            dispatch(storeFilteredMedia(filteredMedia));
        });
    }
}


// WEBPACK FOOTER //
// ./app/media-gallery/redux/actions/media-api.ts